import { colours, shadows } from "@shared/ui.design-system";

const glowEffect = {
  border: `1px solid ${colours.primary.dark}`,
  boxShadow: shadows.bottom.l1
};

export const Select = {
  baseStyle: {
    "&:hover": {
      "& [data-testid='SelectButton']": glowEffect,
      "& [data-testid='SelectList']": glowEffect
    },
    "& > div": {
      zIndex: 3
    }
  }
};

const border = `1px solid ${colours.primary.dark}`;
export const SelectButton = {
  baseStyle: {
    border,
    borderRadius: 4,
    padding: "0.6rem"
  }
};

export const SelectButtonDisabled = {
  baseStyle: {
    ...SelectButton.baseStyle,
    borderColor: colours.secondary.deep,
    cursor: "initial",
    color: colours.primary.medium,
    "&:hover": {
      boxShadow: "none!important",
      borderColor: `${colours.secondary.deep}!important`
    }
  }
};

export const SelectList = {
  baseStyle: {
    borderRadius: 4,
    border,
    display: "inline-block",
    whiteSpace: "nowrap",
    transformOrigin: "center top !important",
    transform: "scale(1) !important",
    padding: 0,
    overflow: "hidden",
    minWidth: "100%",

    "& button": {
      padding: "0.6rem !important"
    },

    "& button:first-of-type": {
      paddingTop: "0.6rem"
    },

    "& button:last-child": {
      paddingBottom: "0.6rem"
    }
  }
};

export const SelectItem = {
  baseStyle: {
    "&:active": {
      background: colours.secondary.warm
    },
    "&.selected": {
      background: colours.secondary.warm
    },
    "&:hover": {
      background: colours.secondary.warm
    },
    "&:focus": {
      background: colours.secondary.warm
    }
  }
};
